export interface RotaComFlag {
  rota: string;
  flag: string;
}

export const ROTAS_COM_FLAGS: RotaComFlag[] = [
  { rota: '/leads', flag: 'leads' },
  { rota: '/empresas', flag: 'empresas' },
  { rota: '/propostas/avaliacao', flag: 'proposta_sales_ops' },
  { rota: '/contratos/avaliacao', flag: 'tratativas_envio_analise' },
  { rota: '/indicadores', flag: 'indicadores_dashboard' },
];

export const FLAGS_FUNCIONALIDADES = {
  LEADS_QUALIFICACAO: 'leads_qualificacao',
  NOTAS_HISTORICO: 'notas_historico',
  TRATATIVAS_CONTRATO: 'tratativas_contrato',
} as const;
